import * as React from 'react';
import { useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import OutlinedInput from '@mui/material/OutlinedInput';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import Chip from '@mui/material/Chip';
import { FormHelperText } from '@mui/material';

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

function getStyles(items, personName, theme) {
  return {
    fontWeight:
      personName.indexOf(items) === -1 ? theme.typography.fontWeightRegular : theme.typography.fontWeightMedium,
  };
}

export default function MultipleSelectChip({ label, lists, changeHandler, obj, objKey, initVal, error, helperText }) {
  const theme = useTheme();
  const [items, setItems] = React.useState(obj ? lists.filter((e) => initVal.includes(e.name)) : initVal ?? []);

  const handleChange = (event) => {
    const {
      target: { value },
    } = event;
    setItems(value);
    changeHandler(obj ? value.map((e) => (objKey ? e[objKey] : e.id)) : value);
  };

  return (
    <FormControl fullWidth error={error}>
      <InputLabel id="demo-multiple-chip-labeli">{label}</InputLabel>
      <Select
        labelId="demo-multiple-chip-labeli"
        id="demo-multiple-chip"
        multiple
        fullWidth
        value={items}
        onChange={handleChange}
        input={<OutlinedInput id="select-multiple-chip" label="Chip" />}
        renderValue={(selected) => (
          <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
            {selected.map((value, i) => (
              <Chip key={i} label={typeof value === 'string' ? value : value?.name} />
            ))}
          </Box>
        )}
        MenuProps={MenuProps}
      >
        {lists.map((item, i) => {
          return (
            <MenuItem key={i} value={item} style={getStyles(item, items, theme)}>
              {typeof item === 'string' ? item : item?.name}
            </MenuItem>
          );
        })}
      </Select>
      {error && <FormHelperText>{helperText}</FormHelperText>}
    </FormControl>
  );
}
